import { createFileRoute, redirect } from '@tanstack/react-router';

import { settingsMenu } from '@/app/navigation/settingsMenu';
import { canOpenRoute } from '@/shared/permissions/PagePermissionContext';
import type { PageStaticData } from '@/shared/routing';

// Opens the first page the settings sidebar offers this user, so "Settings" in the command palette lands on content,
// not an empty pane. The sidebar shows a link by its page's access, so this asks the same. Without a link the page
// stays empty, which no user reaches: the Account security page at the menu's end is hidden by no permission.
export const Route = createFileRoute('/_authenticated/next/settings/_menu/organization/')({
    staticData: { access: { permissions: ['view:organization_settings'] }, chrome: 'none' } satisfies PageStaticData,
    beforeLoad: ({ context }) => {
        const firstLink = settingsMenu()
            .map(({ pages }) => pages)
            .flat()
            .map(({ link }) => link)
            .find((link) => canOpenRoute(context.session, context.routeChainOf(link)));
        if (firstLink !== undefined) {
            throw redirect({ ...firstLink, replace: true });
        }
    },
});
